import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Der eine Kartenkörper des Gastportals. Früher gab es daneben `StayCard` mit anderer Rundung und
 * ohne Schatten — zwei Körper für dieselbe Rolle sahen auf einer Seite wie zwei Produkte aus.
 */
const guestCardVariants = cva('rounded-guest-card transition-colors', {
  variants: {
    tone: {
      surface: 'border border-line bg-bg-elev text-fg shadow-guest-card',
      ink: 'bg-bg-dark text-white',
      forest: 'bg-accent-deep text-white',
    },
    padding: {
      none: '',
      md: 'p-5',
      lg: 'p-6',
    },
  },
  defaultVariants: { tone: 'surface', padding: 'md' },
});

export interface GuestCardProps
  extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof guestCardVariants> {}

export const GuestCard = forwardRef<HTMLDivElement, GuestCardProps>(
  ({ className, tone, padding, ...props }, ref) => (
    <div ref={ref} className={cn(guestCardVariants({ tone, padding }), className)} {...props} />
  ),
);
GuestCard.displayName = 'GuestCard';

export { guestCardVariants };
